import CustomSwitch from "../switch";

export default function BrickConfigFields({brick, config, setConfig}) {
    if (!brick?.configFields?.length) return null;

    return (
        <div className="space-y-2">
            {brick.configFields.map((field) => {
                if (typeof field.showsWhen === 'function' && !field.showsWhen(config)) {
                    return null;
                }

                const value = config?.[field.key] ?? field.defaultValue ?? '';
                const fieldId = field.id || `brick-config-${field.key}`;
                const containerClassName = field.indent ? "ml-4 border-l border-gray-100 pl-3" : undefined;

                if (field.type === 'switch') {
                    return (
                        <div key={field.key} className={containerClassName}>
                            <CustomSwitch
                                type="switch"
                                name={field.key}
                                label={field.label}
                                description={field.helpText}
                                value={value}
                                truthyValue="true"
                                falsyValue="false"
                                onChange={(_event, _name, nextValue) => setConfig({...config, [field.key]: nextValue})}
                                small
                                flipLayout
                            />
                        </div>
                    );
                }

                if (field.type === 'checkbox') {
                    const checked = value === true || value === 'true';

                    return (
                        <div key={field.key} className={containerClassName}>
                            <label htmlFor={field.key} className="flex cursor-pointer items-start gap-2.5">
                                <input
                                    id={field.key}
                                    name={field.key}
                                    type="checkbox"
                                    className="mt-0.5 h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
                                    checked={checked}
                                    onChange={(event) => setConfig({...config, [field.key]: event.target.checked ? 'true' : 'false'})}
                                />
                                <span className="min-w-0">
                                    <span className="block text-sm text-gray-700">{field.label}</span>
                                    {field.helpText ? (
                                        <span className="mt-0.5 block text-xs leading-snug text-gray-500">{field.helpText}</span>
                                    ) : null}
                                </span>
                            </label>
                        </div>
                    );
                }

                if (field.type === 'select') {
                    return (
                        <div key={field.key} className={containerClassName}>
                            <label htmlFor={fieldId} className="mb-1 block text-xs font-medium text-gray-600">{field.label}</label>
                            <select
                                id={fieldId}
                                name={field.key}
                                className="w-full rounded border border-gray-200 px-2 py-1 text-xs"
                                value={value}
                                onChange={(event) => setConfig({...config, [field.key]: event.target.value})}
                            >
                                {(field.options || []).map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                            {field.helpText ? (
                                <div className="mt-1 text-xs leading-snug text-gray-500">{field.helpText}</div>
                            ) : null}
                        </div>
                    );
                }

                return (
                    <div key={field.key} className={containerClassName}>
                        <label htmlFor={fieldId} className="mb-1 block text-xs font-medium text-gray-600">{field.label}</label>
                        <input
                            id={fieldId}
                            min={field.min}
                            max={field.max}
                            step={field.step}
                            className="w-full rounded border border-gray-200 px-2 py-1 text-xs"
                            name={field.key}
                            type={field.type || 'text'}
                            value={value}
                            placeholder={field.placeholder || ''}
                            onChange={(event) => setConfig({...config, [field.key]: event.target.value})}
                        />
                        {field.helpText ? (
                            <div className="mt-1 text-xs leading-snug text-gray-500">{field.helpText}</div>
                        ) : null}
                    </div>
                );
            })}
        </div>
    );
}
